import React from 'react'
import Alert from 'react-bootstrap/Alert'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

const DeleteModal = ({show,setShow,onDelete,deleteType}) => (
	<Modal centered show={show} onHide={()=>setShow(false)}>
		<Modal.Header closeButton>
			Delete Options
		</Modal.Header>
		<Modal.Body>
			{deleteType==='all'&&
				<Alert variant="danger" className="text-dark mb-2">
					<strong className="d-block mr-2">WARNING:</strong>
					YOU ARE DELETING ALL ASSIGNMENTS
				</Alert>
			}
			<Button 
				onClick={()=>{
					if(!window.confirm('Delete all future events?')) return 
					const futureOnly = 1 
					onDelete(futureOnly)
				}}
				block 
				variant="outline-danger" 
				size="sm" 
				className="mb-4 text-left text-wrap">
				Delete program & Remove <strong> only </strong> <strong>FUTURE</strong> workout, task & nutrition data related to this program 
				from <strong>{deleteType==='all'?'ALL CLIENTS':'THIS CLIENT'}</strong>. <strong>You will NOT lose data for completed events</strong>.
			</Button>
			<Button 
				onClick={()=>{
					if(!window.confirm('Wipe the entire program?')) return 
					const futureOnly = 0
					onDelete(futureOnly)
				}}
				block 
				variant="outline-danger" 
				size="sm" 
				className="text-left text-wrap">
				Wipe program from your account. This will delete <strong>ALL</strong> workout, task & nutrition data related to this program 
				from <strong>{deleteType==='all'?'ALL CLIENTS':'THIS CLIENT'}. You WILL LOSE data for completed events.</strong> 
			</Button>
		</Modal.Body>
	</Modal>
)


export default DeleteModal